export default __webpack_public_path__ + "static/media/img_eres_medico.effd0506.svg";